import { createAction, emptyProps, props } from "@ngrx/store";

export const FETCH_SERVICETYPE_LIST = createAction(
    'FETCHSERVICETYPELIST',
   emptyProps
);

export const FETCH_SERVICETYPE_LIST_SUCCESS = createAction(
  'FETCH_SERVICETYPE_LIST_SUCCESS',
  props<{ serviceTypeList: any }>()
);
